namespace RedBullMOBILE360.Sms {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.Sms.ExclusiveOffersGrid')
    export class ExclusiveOffersGrid extends Serenity.EntityGrid<ExclusiveOffersRow, any> {
        protected getColumnsKey() { return ExclusiveOffersColumns.columnsKey; }
        protected getDialogType() { return ExclusiveOffersDialog; }
        protected getIdProperty() { return ExclusiveOffersRow.idProperty; }
        protected getInsertPermission() { return ExclusiveOffersRow.insertPermission; }
        protected getLocalTextPrefix() { return ExclusiveOffersRow.localTextPrefix; }
        protected getService() { return ExclusiveOffersService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}